export class BlurredMenu {
	constructor(menu) {
		this.Menu = menu;
		this.AllowedClicks = ["A", "BUTTON", ".text-faded", "h1", "h2", "h3", "h4", "h5", "h6"];

		this.Init();
	}

	Init() {
		this.Menu.onclick = ev => {
			if (!this.AllowedClicks.find(x => ev.srcElement?.matches(x))) {
				BlurredMenu.Close();
			}
		}
	}

	Open() {
		document.body.removeClass("remove-blur");
		document.body.classList.add("blur");
	}

	static Close() {
		const blurred = document.querySelector(".blur");

		if (blurred) {
			blurred.classList.replace("blur", "remove-blur");

			setTimeout(() => {
				blurred.removeClass("remove-blur");
			}, 500);
		}
	}
}

window.onkeydown = ev => {
	if (ev.key === "Escape") {
		BlurredMenu.Close();
	}
}